import React from 'react';
import { Hero } from '../components/Hero';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CallbackWidget } from '../components/CallbackWidget';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-353">
      <Navigation data-id="element-354" />

      <main data-id="element-355">
        <Hero data-id="element-356" />
        <WhyChooseUs data-id="element-357" />
        <WhyUs data-id="element-358" />
        <Services data-id="element-359" />
        <FAQ data-id="element-360" />
        <Testimonials data-id="element-361" />
        <Consultation data-id="element-362" />
      </main>

      <Footer data-id="element-363" />
      <CookieBanner data-id="element-364" />
      <CallbackWidget data-id="element-365" />
    </div>;
}